import "./_truncated-text.scss";

import classNames from "classnames";

import Tooltip from "../tooltip/Tooltip";
import TooltipContent from "../tooltip/content/TooltipContent";
import Typography, {TypographyProps} from "../typography/Typography";

interface TruncatedTextProps {
  text: string;
  // TODO: Find a way to dynamically determine whether tooltip should appear or not instead of providing a static charLimit
  charLimit: number;
  typographyProps?: Omit<TypographyProps<"p">, "as" | "children">;
}

function TruncatedText({text, charLimit, typographyProps}: TruncatedTextProps) {
  const triggerContent = (
    <Typography
      {...typographyProps}
      customClassName={classNames("is-truncated-text", typographyProps?.customClassName)}>
      {text}
    </Typography>
  );

  return text.length > charLimit ? (
    <Tooltip
      customClassName={"truncated-text__tooltip"}
      content={<TooltipContent>{text}</TooltipContent>}>
      {triggerContent}
    </Tooltip>
  ) : (
    triggerContent
  );
}

export default TruncatedText;
